module.exports = __webpack_public_path__ + "static/TX-0158828d2624648dd957e6da49362fba.svg";